module.exports = __webpack_public_path__ + "static/media/icon-up-page.1cdb7403.svg";